export default "__VITE_ASSET__64515dae__"